<template>
    <HomeLayout>
        <Section
            hero-background
            repeat-background
            fullscreen
            padding-top-half
            padding-bottom-half
        >
            <Container>
                <SectionHeadline>Buchung abgeschlossen</SectionHeadline>

                <div
                    class="flex justify-center text-xl text-primary-text text-center leading-relaxed"
                >
                    Vielen Dank für Ihre Buchung!<br />
                    Wir haben Ihnen eine E-Mail mit den Informationen zu Ihrer
                    Buchung gesendet.
                </div>

                <div class="mt-10 flex justify-center items-center">
                    <img src="/images/pic.png" class="h-80" />
                </div>

                <div class="mt-10 flex justify-center">
                    <Link :href="route('home')">
                        <StyledButton background-primary>
                            <ArrowLeftIcon class="h-5 w-5 mr-2" /> Zurück zur
                            Startseite
                        </StyledButton>
                    </Link>
                </div>
            </Container>
        </Section>
    </HomeLayout>
</template>

<script>
import HomeLayout from "@/Layouts/HomeLayout.vue";
import Section from "@/Components/Section.vue";
import SectionHeadline from "@/Components/SectionHeadline.vue";
import Container from "@/Components/Container.vue";
import { Link } from "@inertiajs/inertia-vue3";
import StyledButton from "@/Components/StyledButton.vue";
import { ArrowLeftIcon } from "@heroicons/vue/outline";

export default {
    components: {
        HomeLayout,
        Section,
        SectionHeadline,
        Container,
        StyledButton,
        Link,
        ArrowLeftIcon,
    },
};
</script>
